import intl from "react-intl-universal";
import { formatCurrency } from "../../../../Utils/formatters";
import { getLimitTone, resolveLimitProgress } from "../../Pix/PixLimits/constants";
import { StablesLimitUsageList } from "../../Stables/components/StablesLimitUsageList";

/**
 * Shared limit card (Stables / Pix / other rails): used · remaining · limit + bar.
 */
export const BaasLimitUsageCard = ({
  label,
  description,
  used = 0,
  max = 0,
  usage,
  formatValue = formatCurrency,
  extra = null,
  comingSoon = false,
}) => {
  const usedAmount = Number(used) || 0;
  const maxAmount = Number(max) || 0;
  const remaining = Math.max(0, maxAmount - usedAmount);
  const progress = resolveLimitProgress(usedAmount, maxAmount);
  const barWidth = usedAmount > 0 ? Math.max(progress.barPercent, 1) : 0;
  const tone = getLimitTone(progress.isLessThanOne ? 0 : progress.barPercent);
  const showUsage = Array.isArray(usage);

  return (
    <div className="min-w-0 w-full rounded-lg border border-dashed border-gray-200 bg-gray-50/70 p-3.5 dark:border-brand-dark-border dark:bg-brand-dark-elevated/40">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-dark dark:text-gray-100">
            {label}
          </p>
          {description ? (
            <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{description}</p>
          ) : null}
        </div>
        {comingSoon ? (
          <span className="shrink-0 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-gray-500 dark:bg-brand-dark-surface dark:text-gray-400">
            {intl.get("baas.pix.limits.comingSoon")}
          </span>
        ) : null}
      </div>

      <div className="mt-4 grid grid-cols-3 gap-2">
        <div className="min-w-0">
          <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {intl.get("baas.stablesWallet.limits.usedLabel")}
          </p>
          <p className="mt-0.5 break-words text-sm font-bold text-brand-dark dark:text-gray-100">
            {formatValue(usedAmount)}
          </p>
        </div>
        <div className="min-w-0">
          <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {intl.get("baas.stablesWallet.limits.remainingLabel")}
          </p>
          <p className="mt-0.5 break-words text-sm font-bold text-emerald-600 dark:text-emerald-400">
            {formatValue(remaining)}
          </p>
        </div>
        <div className="min-w-0">
          <p className="text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
            {intl.get("baas.stablesWallet.limits.limitLabel")}
          </p>
          <p className="mt-0.5 break-words text-sm font-bold text-brand-dark dark:text-gray-100">
            {formatValue(maxAmount)}
          </p>
        </div>
      </div>

      {extra}

      <div className="cartoes-progress mt-4">
        <div className="cartoes-progress__track">
          <div
            className={`cartoes-progress__fill cartoes-progress__fill--${tone}`}
            style={{
              width: `${barWidth}%`,
              ...(barWidth > 0 ? { minWidth: "4px" } : null),
            }}
          />
        </div>
        <p className="cartoes-progress__label">
          {progress.isLessThanOne
            ? intl.get("baas.stablesWallet.limits.percentUsedLessThanOne")
            : intl.get("baas.stablesWallet.limits.percentUsed", {
                percent: progress.labelPercent,
              })}
        </p>
      </div>

      {showUsage ? <StablesLimitUsageList usage={usage} /> : null}
    </div>
  );
};

export default BaasLimitUsageCard;
